import React from 'react';

const formatTime = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

const FormatTime = (timestamp) => {
  const formattedTime = formatTime(timestamp);

  return (
    <span>{formattedTime}</span>
  );
};

export const  convertirTimestampEnHHMM = (timestamp) => {
  // Convertir le timestamp en secondes
  var heures = Math.floor(timestamp / 3600);
  var minutes = Math.floor((timestamp % 3600) / 60);

  // Ajouter un zéro devant les chiffres < 10
  heures = (heures < 10) ? "0" + heures : heures;
  minutes = (minutes < 10) ? "0" + minutes : minutes;

  // Retourner l'heure au format HH:MM
  return heures + ":" + minutes;
}

export default FormatTime;
